function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircleRightOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.992 15.988c0 8.24-6.74 14.98-14.98 14.98s-14.98-6.74-14.98-14.98 6.74-14.98 14.98-14.98 14.98 6.74 14.98 14.98zm-2.183 0c0-7.037-5.76-12.797-12.797-12.797-7.037 0-12.797 5.76-12.797 12.797 0 7.037 5.76 12.797 12.797 12.797 7.037 0 12.797-5.76 12.797-12.797z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.197 9.99l-1.414 1.415L19.379 15H8.793v2h10.586l-3.596 3.595 1.414 1.415 6.01-6.01-6.01-6.01z",
    fill: props.color
  }));
}

export default SvgIconArrowCircleRightOutline;